//Library Imports
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

//Local Imports
import store from "store";
import { AUTOMATION_EVENTS } from "constants/types/automationTypes";
import TriggerItem from "./TriggerItem";
import { ReactComponent as ReceiveEmail } from "../../../assets/img/icons/ReceiveEmail.svg";
import { ReactComponent as ReadEmail } from "../../../assets/img/icons/ReadEmail.svg";
import { ReactComponent as ClickEmail } from "../../../assets/img/icons/clickEmail.svg";
import { ReactComponent as ShareProfile } from "../../../assets/img/icons/shareProfile.svg";
import { RootState } from "store";
import EmptyTabInfo from "modules/Content/Shared/EmptyTabInfo";
import { IEventData } from "../interfaces";
import EventLoader from "./EventLoader";
import { addActionModal, resetSelectedPreviewEmailId } from "../actions";

interface ISelectTriggerProps {
  selectedTriggerId: number;
  setSelectedTrigger: (id: number) => void;
  goBackFunction: () => void;
}

const SelectTrigger: React.FC<ISelectTriggerProps> = (props) => {
  // Props
  const { selectedTriggerId, setSelectedTrigger } = props;

  // Redux States
  const eventsData = useSelector((state: RootState) => state.automation.events.data);
  const searchedEventsData = useSelector((state: RootState) => state.automation.events.searchedData);
  const loading = useSelector((state: RootState) => state.automation.events.loading);

  // Local States
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const [eventsList, setEventsList] = useState<IEventData[]>([]);
  const [searchedEventsList, setSearchedEventsList] = useState<IEventData[]>([]);

  // Local Variables
  const icons: { [key: string]: any } = {
    received: <ReceiveEmail />,
    opened: <ReadEmail />,
    clicked: <ClickEmail />,
    profile: <ShareProfile />,
  };

  // first Render
  useEffect(() => {
    store.dispatch(addActionModal(false));
    resetSelectedPreviewEmailId();
  }, []);


  // Component Logic
  useEffect(() => {
    if (isSearched) {
      setSearchedEventsList(searchedEventsData);
    } else {
      setEventsList(eventsData);
    }
  }, [eventsData, searchedEventsData]);

  const updateSearchTermInStore = (value: string) => {
    store.dispatch({
      type: AUTOMATION_EVENTS.SET_SEARCH_TERM,
      payload: value,
    });
  };

  const selectTriggerHandler = (id: number) => {
    setSelectedTrigger(id);
  };

  return (
    <Wrapper>
      <div className="list-of-triggers d-flex align-items-start">
        {loading ? (
          <>
            <EventLoader />
            <EventLoader />
            <EventLoader />
          </>
        ) : isSearched ? (
          searchedEventsList.length > 0 ? (
            searchedEventsList.map((event: IEventData) => {
              if (event.id !== 9)
                return (
                  <div key={event.id} onClick={() => selectTriggerHandler(event.id)}>
                    <TriggerItem
                      active={selectedTriggerId === event.id}
                      title={event.title}
                      info={event.info}
                      icon={icons[event.iconType]}
                      eventData={event}
                    />
                  </div>
                );
            })
          ) : (
            <EmptyTabInfo description={"No Events found against your search."}></EmptyTabInfo>
          )
        ) : eventsList.length > 0 ? (
          eventsList.map((event: IEventData) => {
            if (event.id !== 9)
              return (
                <div key={event.id} onClick={() => selectTriggerHandler(event.id)}>
                  <TriggerItem
                    active={selectedTriggerId === event.id}
                    title={event.title}
                    info={event.info}
                    icon={icons[event.iconType]}
                    eventData={event}
                  />
                </div>
              );
          })
        ) : (
          <EmptyTabInfo description={"No Events available."}></EmptyTabInfo>
        )}
      </div>
    </Wrapper>
  );
};

export default SelectTrigger;

const Wrapper = styled.div`
  width: calc(100% - 200px);
  .email-name {
    font-size: 26px !important;
    @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 22px !important;
    }
  }
  .select-trigger-wrapper {
    width: 100%;
    display: block;
    margin-top: 30px;
  }

  .list-of-triggers {
    padding: 38px 45px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 38px 25px;
    }
    .ant-popover {
      max-width: 210px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: 185px;
      }
      .ant-popover-arrow {
        width: 15px;
        height: 15px;
      }
      .ant-popover-inner {
        min-width: 285px;
        border-radius: 10px;
        .ant-popover-inner-content {
          font-size: 16px;
          font-weight: 500;
          letter-spacing: -0.4px;
          line-height: 20px;
          color: #0f0f0f;
          font-family: "Roboto", sans-serif;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
  }
`;
